<template>
    <div class="fw-billing">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="fwb-top">
            <div class="fwbt-s">
                <div class="fwtc-item" >
                    <span class="fwbt-c1">创建套餐+</span>
                </div>
                <div class="fwtc-item" >
                    <span class="fwbt-c1" @click="toAddMember">创建客户+</span>
                </div>
                <div class="fwtc-item" style="border-right: #EEEEEE solid 0px">
                    <span class="fwbt-c1" @click="toMembers">选择会员</span>
                </div>
            </div>
            <div class="fwbt-x">
                <div class="fwtc-item1">
                    <span class="fwbt-t1" v-if="member&&member.id">{{member.memberName}}</span>
                    <span class="fwbt-t1" v-if="!member||!member.id">散客</span>
                    <span class="fwbt-b">客户名称</span>
                </div>
                <div class="fwtc-item1" v-if="mbCard&&mbCard.id" >
                    <span class="fwbt-t1">{{mbCard.cardName}}</span>
                    <span class="fwbt-b">{{mbCard.balance}}</span>
                </div>
            </div>
        </div>
        <div class="fw-kdtype">
            <div class="fw-leibie">
                <span :class="{'lbActive':lbIndex==0}" class="names" @click="setType(0)">套餐包</span>
                <span :class="{'lbActive':lbIndex==1}" class="names" @click="setType(1)">单项</span>
                <span :class="{'lbActive':lbIndex==2}" class="names" @click="setType(2)">月/季/年卡</span>
            </div>
            <Tcb v-if="lbIndex==0" @toTcbChoose="toTcbChoose"/>
            <Dxtc v-if="lbIndex==1" @toTcbChoose="toTcbChoose"/>
<!--            <Specs v-if="lbIndex==2" @toSpecChoose="toSpecChoose" :memberId="member.id"/>-->
        </div>
        <div class="fw-btn">
            <div class="mingxi" @click="toMx">
                <div class="mingxi-text">
                    <span style="font-size: 13px">明细查看</span>
                    <span style="margin-top: 5px;font-size: 20px">
                    <span style="font-size: 10px;margin-right: 5px">¥</span>{{total}}</span>
                </div>
            </div>
            <div class="baocun" @click="jiesuan()">
                <span class="baocun-btn">提交</span>
            </div>
        </div>
        <van-popup v-model="mxShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <div style="padding: 15px;">
                <div class="fw-mx">
                    <div class="fw-mx-nr">
                        <span style="height: 32px;font-size: 15px;line-height: 32px" >{{member.memberName}}</span>
                        <div class="fw-mx-items">
                            <div class="fw-mx-item" v-for="(item,index) in datas">
                                <div class="fwmxi-info">
                                    <span class="fm-name">{{item.commodityName}}</span>
                                    <span class="fm-jg">¥{{item.price}}</span>
                                    <span class="fm-num">x1</span>
                                    <span class="fm-btn" @click="delData(index,1)">删除</span>
                                </div>
                                <span class="mxemp" v-for="emp in item.emps">{{emp.empName}} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="mbShow" position="bottom" closeable lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;">
            <Memmbers ref="mbs" @setMember="setMember" @sanke="sanke" />
        </van-popup>
        <van-popup v-model="addShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <AddMemmber ref="addmb" @gbMember="gbMember" :addType="addType" />
        </van-popup>
        <van-popup v-model="jsShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 77%;">
            <Pay v-if="jsShow" ref="pay" @gbPay="gbPay" :payItem="payItem"/>
        </van-popup>
    </div>
</template>

<script>
    import {formatDate, getCookie,} from "../../utils/auth";
    import AddMemmber from "../common/addMember";
    import Memmbers from "../common/members";
    import Pay from "../common/pay";
    import Tcb from "./list/tcbs";
    import Dxtc from "./list/dxs";

    export default {
        components: {AddMemmber,Memmbers, Tcb, Dxtc,Pay},
        data() {
            return {
                title: '套餐/次卡',
                deptId: '',
                deptName: '',
                roomId: '',
                token: '',
                active: 0,
                lbIndex: '0',

                datas: [],
                total: 0,

                mxShow: false,
                mbShow: false,

                member: {},
                mbCard: {},

                addType:'kd',
                addShow: false,

                jsShow: false,
                payItem:{},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.deptName = this.fwUser.deptName
            this.token = this.fwUser.token
        },
        methods: {
            toAddMember(){
                this.addShow=true
                if (this.$refs.addmb){
                    this.$refs.addmb.chushi();
                }
            },
            gbMember(member){
                this.member=member
                this.addShow=false
            },

            toMembers(){
                this.mbShow = true
                if (this.$refs.mbs){
                    this.$refs.mbs.chushi();
                }
            },
            toMdItems(){
                if (!this.member.id) {
                    return;
                }
                this.tcShow=true
            },
            toScItems(){
                if (!this.member.id) {
                    return;
                }
                this.scShow=true
            },
            setType(lbIndex) {
                this.lbIndex = lbIndex
            },

            sanke() {
                this.$notify({type: 'danger', message: '套餐不能选择散客'});
            },

            setMember(data) {
                this.member = data.mb
                this.mbCard = data.card
                this.mbShow = false
            },

            delData(index,type) {
                if (type==1){
                    let item = this.tcbList[index];
                    this.tcbList.splice(index, 1)
                    var to = parseFloat(this.total) - parseFloat(item.price);
                    this.total = to.toFixed(1)
                }
            },

            toMx() {
                if (this.datas.length > 0) {
                    this.mxShow = true
                } else {
                    this.$notify("没添加任何商品!");
                }
            },
            jiesuan() {
                if (!this.member.id) {
                    this.$notify({type: 'danger', message: '请选择会员'});
                    return;
                }
                if (this.datas.length == 0) {
                    this.$notify({type: 'danger', message: '请选择套餐'});
                    return;
                }
                var mcId = ''
                if (this.mbCard && this.mbCard.id) {
                    mcId = this.mbCard.id
                }
                var data = {
                    composeStr: JSON.stringify(this.datas),
                    total: this.total,
                    memberId: this.member.id,
                    mcId: mcId,
                    orderSex: this.member.sex,
                    token: this.token,
                    deptId:this.deptId,
                    payType:this.payType,
                }
                if (this.radio == 2) {
                    data.xdTime = this.kdDate
                }
                this.payItem={
                    orderType:'tc',
                    data:data,
                    totalStr:this.total.toString(),
                }
                if(this.member&&this.member.id){
                    this.payItem.member=this.member
                }
                if(mcId){
                    this.payItem.cardId=mcId
                }
                this.jsShow=true
            },
            gbPay(){
                this.jsShow = false
            },

            toTcbChoose(data) {
                this.datas.push(data.item)
                this.total = parseFloat(this.total) + parseFloat(data.total)
            },

            guanbi(item) {
                this.items.push(item)
                this.tcShow = false
                this.scShow = false
            },
            toShiJian(type) {
                this.sjShow = true
            },
            queding(val) {
                let date = formatDate(val, 'yyyy-mm-dd')
                this.kdDate = date
                this.quxiao()
            },
            quxiao() {
                this.sjShow = false
            },

            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
            //计算价格
            setPrice(item) {
                item.price = item.oglPrice
                if (item.discount == 1) {
                    if (this.mbCard && this.mbCard.id) {
                        if (item.itemVips.length > 0) {
                            item.itemVips.forEach(vip => {
                                if (vip.cardId == this.mbCard.cardId) {
                                    item.price = vip.vipPrice;
                                }
                            })
                        } else {
                            //计算会员价
                            if (this.mbCard.itemDiscount != 0) {
                                item.price = this.calculationPrice(item.price, this.mbCard.itemDiscount)
                            }
                        }
                    }
                }
            },

            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-billing {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
    }

    .fwb-top {
        display: flex;
        flex-direction: column;
    }

    .fwbt-s {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: #eeeeee solid 1px;
    }

    .fwbt-cz {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .fwbt-x {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: #eeeeee solid 1px;
    }

    .fwtc-item {
        font-size: 13px;
        height: 46px;
        width: 33.3%;
        display: flex;
        flex-direction: column;
        text-align: center;
        border-right: #eeeeee solid 1px;
    }

    .fwtc-item1 {
        height: 46px;
        width: 33.3%;
        display: flex;
        flex-direction: column;
        text-align: center;
        border-right: #eeeeee solid 1px;
    }

    .fwbt-item2 {
        height: 46px;
        line-height: 46px;
        width: 25%;
        text-align: center;
        border-right: #eeeeee solid 1px;
        font-size: 14px;
    }
    .fwbt-t {
        font-size: 13px;
        color: red;
        height: 32px;
        line-height: 32px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .fwbt-t1 {
        font-size: 13px;
        height: 32px;
        line-height: 32px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .fwbt-c {
        color: red;
        height: 46px;
        line-height: 46px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .fwbt-c1 {
        height: 46px;
        line-height: 46px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .fwbt-b {
        font-size: 11px;
        color: #C4C4C4;
        margin-bottom: 5px;
    }

    .fw-kdtype {
    }

    .fw-leibie {
        display: flex;
        flex-direction: row;
        border-bottom: #eeeeee solid 1px;
    }

    .fw-leibie span {
        width: 33.3%;
        font-size: 15px;
        height: 32px;
        line-height: 32px;
        text-align: center;
    }

    .lbActive {
        color: #2b94ff;
    }

    .names {
        width: 33.3%;
        border-right: #eeeeee solid 1px;
    }


    .fw-btn {
        width: 100%;
        height: 50px;
        position: fixed;
        bottom: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #ffffff;
    }


    .fw-mx {
        display: flex;
        flex-direction: column;
    }

    .fw-mx-nr {
        display: flex;
        flex-direction: column;
    }

    .fw-mx-items {
        display: flex;
        flex-direction: column;
        border-top: #EEEEEE solid 1px;
        margin-top: 5px;
    }

    .mxemp {
        font-size: 10px;
        padding: 5px 0px;
        color: #999999;
    }

    .fw-mx-item {
        display: flex;
        flex-direction: column;
        background-color: #F7F7F7;
        margin-top: 5px;
        padding: 0 8px;
        padding-bottom: 3px;
    }

    .fwmxi-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 32px;
    }

    .fm-name {
        font-size: 13px;
        width: 45%;
    }

    .fm-jg {
        font-size: 11px;
        width: 25%;
    }

    .fm-num {
        width: 15%;
        font-size: 11px;
    }

    .fm-btn {
        font-size: 12px;
        background-color: red;
        padding: 2px 8px;
        color: #ffffff;
    }

    .mbtb {
        display: block;
        text-align: center;
    }
    .jisuanje {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
        height: 43px;
        line-height: 50px;
        border-bottom: #EEEEEE solid 1px;
    }
    .jisuanfs {
        width: 90%;
        margin: auto;
        font-size: 13px;
        padding-top: 10px;
    }

    .radio-btn {
        height: 30px;
        font-size: 13px;
    }

    ::v-deep .van-radio__icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -ms-flex: none;
        flex: none;
        height: 1em;
        font-size: 13px;
        line-height: 1em;
        cursor: pointer;
        position: absolute;
        right: 30px;
    }
    .jiesuan-btn {
        width: 100%;
        position: fixed;
        bottom: 0px;
    }

    .jiesuanbtn {
        width: 100%;
        text-align: center;
        height: 40px;
        background-color: red;
        color: #ffffff;
    }

</style>
